import type { ReactNode } from 'react';
import { cx } from './cx.js';

/**
 * State as a pill instead of a sentence. `.pill` has existed in the stylesheet
 * the whole time and was used exactly zero times in the configuration pages —
 * every status was prose like "Configured: yes" in muted 12px.
 */
export type Tone = 'ok' | 'warn' | 'error' | 'neutral';

export function StatusPill({ tone, children }: { tone: Tone; children: ReactNode }) {
  return (
    <span className={cx('ui-pill', `ui-pill--${tone}`)}>
      <span className="ui-pill__dot" aria-hidden="true" />
      {children}
    </span>
  );
}
